import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import "./LabelTag.scss";

export const LabelTag = ({
  className,
  color = "default",
  type = "filled",
  size = "md",
  text,
  ...props
}) => {
  return (
    <span
      className={clsx("hireart-ds-label-tag", type, color, size, className)}
      {...props}
    >
      {text}
    </span>
  );
};

LabelTag.propTypes = {
  color: PropTypes.oneOf([
    "default",
    "warning",
    "inactive",
    "success",
    "alert",
    "info",
  ]),
  size: PropTypes.oneOf(["md", "sm", "xs"]),
  type: PropTypes.oneOf(["filled", "outlined", "text"]),
  text: PropTypes.string,
};

